import React, { useContext } from "react";
// import {pathMaker} from "../../../utils/helperFunctions";
import { pathMaker } from "utils/helperFunctions";
import { Link } from "react-router-dom";
import AdminOperationArticle from "./AdminOperationArticle";
import articlePic from "../../assets/images/article.png";
import { MdDateRange } from "react-icons/md";
// import AuthenticationContext from "../../../context/Authentication/AuthenticationContext.ts";
import AuthenticationContext from "context/Authentication/AuthenticationContext.ts";

const Article = ({ article, isSize = false }) => {
  const auth = useContext(AuthenticationContext);
  const dateShow = new Date(+article?.mtm * 1000).toLocaleDateString("fa");
  return (
    // <div className="card col-12 col-sm-6 col-md-4 col-lg-3">
    <div
      className={`${
        isSize == true ? "w-100" : "col-12 col-sm-6 col-md-4 col-lg-3 pd-x-4"
      }`}
    >
      <div className="card mr-y-4">
        {auth.userInfo?.userType == 0 && (
          <AdminOperationArticle ArticleData={article} id={article.id} />
        )}

        <img
          style={{ height: isSize && "143px" }}
          src={
            article.file.length !== 0
              ? pathMaker(article?.file[0]?.url)
              : articlePic
          }
          alt={article?.title}
        />
        <div className="card-body pd-12">
          <h6 className="card-title font-14-600">{article?.title}</h6>
          <div className="box-desc">
            <p className="font-12-400 text-secondary text-opacity-75 desc">
              {article?.description}
            </p>
          </div>
        </div>
        <div className="card-footer bg-light bg-opacity-10 pd-x-8">
          <div className="d-flex w-100 justify-content-between align-items-center">
            <div className="d-flex">
              <MdDateRange className="text-secondary text-opacity-50 wh-18 mr-l-4" />
              <span className="font-12-500 text-secondary text-opacity-50 mb-0">
                {dateShow}
              </span>
            </div>
            <Link
              to={`/blog/post/${article?.id}`}
              className="btn btn-outline-primary font-12-500"
            >
              مطالعه مقاله
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article;
